import { z } from 'zod';

export const NoticeAiDataSchema = z.object({
  title: z.string().min(3).max(100),
  description: z.string().min(10).max(5000),
  publishOn: z.string().optional(),
  removeAfter: z.string().optional(),
  noticeStatus: z.enum(['active', 'draft', 'completed']).default('active'),
  isGradeNotice: z.boolean().default(false),
  gradeId: z.string().optional(),
  gradeName: z.string().optional(),
  memberType: z.array(z.string()).default(['admin', 'member', 'treasurer']),
  imagePrompt: z.string().optional(),
  shouldGenerateImage: z.boolean().default(true),
  requiresImageGen: z.boolean().default(true),
  imageThemeDescription: z.string().optional(),
  selectedStyleId: z.string().optional(),
});

export type NoticeAiData = z.infer<typeof NoticeAiDataSchema>;
